import script from "./CargarArchivo.vue?vue&type=script&setup=true&lang=js"
export * from "./CargarArchivo.vue?vue&type=script&setup=true&lang=js"

import "./CargarArchivo.vue?vue&type=style&index=0&id=265849c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-265849c0"]])

export default __exports__